// extracted by mini-css-extract-plugin
export default {"wrapper":"Badge_wrapper__sI5Nq","light-grey":"Badge_light-grey__EpDkr","green":"Badge_green__SB+AB","red":"Badge_red__zufLp"};